<script setup lang="ts">
import { FormattedCurrency } from "~/components/ui/FormattedCurrency";

export interface SharedPriceProps {
  discounted?: boolean;
  hasAsterisk?: boolean;
  strikethrough?: boolean;
  value: number;
}

defineProps<SharedPriceProps>();
</script>

<template>
  <span class="inline-flex gap-1" :class="{ 'text-signal-red': discounted }">
    <slot name="beforePrice" />
    <span
      ><span :class="{ 'line-through': strikethrough }"><FormattedCurrency :value="value" /></span
      ><span v-if="hasAsterisk" class="pl-0.5 font-normal text-black">*</span></span
    >
    <slot name="afterPrice" />
  </span>
</template>
